<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon bg-mean-fruit rounded-circle"><i class="pe-7s-tools text-white"></i></div>
        <div>
          Machine Management
          <div class="page-title-subheading">Define machines, then assign them to product steps.</div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="mb-3 card">
        <div class="card-header d-flex justify-content-between align-items-center">
          Machines
          <button class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#machineModal" (click)="openAddModal()">
            <i class="fa fa-plus mr-1"></i> Add Machine
          </button>
        </div>
        <div class="card-body">
          <div *ngIf="loading" class="text-center py-5">
            <span class="spinner-border text-primary"></span>
          </div>
          <vio-table-v2 *ngIf="!loading" [tableData]="tableData" [tableConfig]="tableConfig"></vio-table-v2>
        </div>
      </div>
    </div>
  </div>

  <!-- Add/Edit Machine modal -->
  <div class="modal fade" id="machineModal" tabindex="-1" aria-hidden="true" appAppendToBody>
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ operation === 'Add' ? 'Add Machine' : 'Edit Machine' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <app-bilingual-name-field
            label="Name"
            placeholder="e.g. Cutting Press 1"
            [(name)]="machineForm.name"
            [(nameMr)]="machineForm.nameMr"
          ></app-bilingual-name-field>
          <div class="row">
            <div class="col-md-6 form-group">
              <label class="required">Code</label>
              <input
                class="form-control"
                placeholder="e.g. CUT-01"
                autocomplete="off"
                [(ngModel)]="machineForm.code"
                [disabled]="operation === 'Edit'"
              />
              <small class="text-muted" *ngIf="operation === 'Edit'">Code can't be changed after creation.</small>
            </div>
            <div class="col-md-6 form-group">
              <label>Machine Type</label>
              <select class="form-select" [(ngModel)]="machineForm.machineTypeId">
                <option value="">— None —</option>
                <option *ngFor="let machineType of machineTypes" [value]="machineType._id">{{ machineType.name }}</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 form-group">
              <label>Location</label>
              <input class="form-control" placeholder="e.g. Bay A" autocomplete="off" [(ngModel)]="machineForm.location" />
            </div>
            <div class="col-md-6 form-group">
              <label>Notes</label>
              <input class="form-control" placeholder="Optional" autocomplete="off" [(ngModel)]="machineForm.notes" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" #machineModalCloseBtn>Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveMachine()">
            <i class="fa" [class.fa-plus]="operation === 'Add'" [class.fa-check]="operation === 'Edit'"></i>
            {{ operation === 'Add' ? 'Add Machine' : 'Save Changes' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
